module.exports = __webpack_public_path__ + "static/media/Protocol-Formoplast-OSA-300062017_clean.61e5ac2e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2017/Protocol-Formoplast-OSA-300062017_clean.pdf
// module id = 148
// module chunks = 0